<template>
    <div class="restricted-height"
         :style="buildStyle"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "RestrictedHeight",
    data: function() {
        return {
            myHeight: 0,
            myOffset: 0,
            pageWidth: 0, 
            mobileWidth: 768,
        }
    },
    props: {
        minHeight: {
            type: Number,
            default: 500,
        },
        mobile: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateDimensions() {
            this.pageWidth = Math.floor(
                window.visualViewport ? window.visualViewport.width : window.innerWidth
            );

            if (this.mobile && (this.pageWidth <= this.mobileWidth)) {
                // On mobile resolution, collapse to minimum height
                this.myHeight = this.minHeight;
                return;
            }

            this.myHeight = Math.floor(
                window.visualViewport ? window.visualViewport.height : window.innerHeight
            );
        },
    },
    computed: {
        buildStyle() {
            let buildHeight = this.myHeight - this.myOffset;
            if (buildHeight < this.minHeight) {
                buildHeight = this.minHeight;
            }
            return `height: ${buildHeight}px;`;
        }
    },
    mounted: function() {
        this.$nextTick(() => {
            this.myOffset = this.$el.offsetTop;
            this.updateDimensions();
            window.addEventListener('resize', this.updateDimensions);
        });
        
    },
}
</script>

<style>

</style>